// @flow

import axios from "axios";

import {
  BUBA_API_URL,
  BUBA_API_URL_V2,
  BUBA_API_AUTH_URL,
  getEnvironmentVariable
} from "../utils/environment";
import { addStatusCodeInterceptorToInstance } from "../utils/loggers";

export const getBubaClient = (v2 = false) => {
  const bubaClient = axios.create({
    baseURL: getEnvironmentVariable(v2 ? BUBA_API_URL_V2 : BUBA_API_URL),
    headers: { "Content-Type": "application/vnd.api+json" }
  });

  addStatusCodeInterceptorToInstance(bubaClient);

  return bubaClient;
};

const getBubaClientAuth = () => {
  const bubaClientAuth = axios.create({
    baseURL: getEnvironmentVariable(BUBA_API_AUTH_URL),
    headers: { "Content-Type": "application/vnd.api+json" }
  });

  addStatusCodeInterceptorToInstance(bubaClientAuth);

  return bubaClientAuth;
};

export const bubaClient = getBubaClient();
export const bubaClientAuth = getBubaClientAuth();
export const bubaClientV2 = getBubaClient(true);
